import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleUp,
  faBarcode,
  faBars,
  faCheck,
  faCircleQuestion,
  faEraser,
  faExclamationCircle,
  faExclamationTriangle,
  faFamily,
  faFilter,
  faFolder,
  faHouse,
  faInfo,
  faMaximize,
  faMemoCircleInfo,
  faMinimize,
  faPage,
  faPlus,
  faScrewdriverWrench,
  faUser,
  faXmarkLarge,
} from '@fortawesome/pro-light-svg-icons';

import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import iconMixin from './style-icons-mixin';

library.add(
  faAngleDown,
  faAngleUp,
  faBarcode,
  faBars,
  faCheck,
  faCircleQuestion,
  faEraser,
  faExclamationCircle,
  faExclamationTriangle,
  faFamily,
  faFilter,
  faFolder,
  faHouse,
  faInfo,
  faMaximize,
  faMemoCircleInfo,
  faMinimize,
  faPage,
  faPlus,
  faScrewdriverWrench,
  faUser,
  faXmarkLarge,
);

Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.mixin(iconMixin);

export default {};
